import type { AreaId } from '../../types/pulse'

/**
 * One colour per journey area, used consistently across every result surface
 * so a delegate can read "their" colour at a glance.
 */
export const AREA_BAR: Record<AreaId, string> = {
  diagnosis: 'bg-blue',
  treatment: 'bg-plum',
  followup: 'bg-teal',
}

export const AREA_SOFT: Record<AreaId, string> = {
  diagnosis: 'bg-blue/15',
  treatment: 'bg-plum/15',
  followup: 'bg-teal/15',
}

export const AREA_BORDER: Record<AreaId, string> = {
  diagnosis: 'border-blue/40',
  treatment: 'border-plum/40',
  followup: 'border-teal/40',
}

/** Bar colours for the non-area charts, in reading order. */
export const SERIES = ['bg-blue', 'bg-teal', 'bg-plum', 'bg-amber', 'bg-band', 'bg-navy2']
